$(function(){
    $('.slider').slick({
        autoplay: true,       //自動再生
        autoplaySpeed: 3000,  //自動再生のスピード
        speed: 800,           //スライドするスピード
        dots: true,           //スライド下のドット
        arrows: true,         //左右の矢印
        infinite: true,       //永久にループさせる
        pauseOnHover: false,  // マウスオーバー時にスライドを停止しない
    });
});